import React from 'react';
import { Evidence2 } from '@eas/common-web';
import { DictionaryDecisionType } from '../../models';
import { useValidationSchema } from './dict-decision-types-schema';
import { EvidenceAPI, PageKey, Permission, EntityName } from '../../enums';
import { ExportTags } from '../../enums/export-tags';
import { useDictionaryEvidence } from '../../components/evidence/dictionary-evidence/dictionary-evidence';
import { DictionaryDecisionTypesFields } from './dict-decision-types-fields';
import { usePermission } from '../../components/permission/perm-evidence-hook';

export function DictionaryDecisionTypes() {
  const validationSchema = useValidationSchema();

  const permissions = usePermission<DictionaryDecisionType>({
    options: {
      NEW: [Permission.MuvDecisionType.MUV_DECISION_TYPE_CREATE],
      EDIT: [Permission.MuvDecisionType.MUV_DECISION_TYPE_UPDATE],
      REMOVE: [Permission.MuvDecisionType.MUV_DECISION_TYPE_DELETE],
      CHECK: [
        Permission.MuvDecisionType.MUV_DECISION_TYPE_CREATE,
        Permission.MuvDecisionType.MUV_DECISION_TYPE_UPDATE,
      ],
      SAVE: [
        Permission.MuvDecisionType.MUV_DECISION_TYPE_CREATE,
        Permission.MuvDecisionType.MUV_DECISION_TYPE_UPDATE,
      ],
      CLOSE: [
        Permission.MuvDecisionType.MUV_DECISION_TYPE_CREATE,
        Permission.MuvDecisionType.MUV_DECISION_TYPE_UPDATE,
      ],
    },
  });

  const evidence = useDictionaryEvidence<DictionaryDecisionType>(
    {
      identifier: PageKey.DICTIONARY_DECISION_TYPES,
      apiProps: {
        url: EvidenceAPI.DICTIONARY_DECISION_TYPES,
      },
      tableProps: {
        tableName: 'Druhy rozhodnutí',
        reportTag: ExportTags.DICTIONARY_DECISION_TYPES,
        defaultSorts: [],
      },
      detailProps: {
        entityName: EntityName.DECISION_TYPE,
        codePrefix: 'DECISION_TYPE',
        validationSchema,
        GeneralFieldsComponent: DictionaryDecisionTypesFields,
        toolbarProps: {
          title: 'Druh rozhodnutí',
          showBtn: permissions,
        },
      },
    },
    Permission.MuvDecisionType.MUV_DECISION_TYPE_INVALIDATE,
    Permission.MuvDecisionType.MUV_DECISION_TYPE_REVALIDATE
  );

  return <Evidence2 {...evidence} />;
}
